import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: alternate/personal email address
 * @returns {ReactElement} textbox prompting for alternate/personal email address
 */
const AlternateEmail = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.ALTERNATE_EMAIL}
			label='Preferred Work Email Address'
			helperText="We will be sending notifications to this alternate email address, so please ensure you provide an email address the new user checks regularly. Ideally, this should be associated with the new user's organization."
			required
		/>
	);
};
export default AlternateEmail;
